import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import $ from 'jquery';
import 'justifiedGallery/dist/js/jquery.justifiedGallery.min.js';
import 'justifiedGallery/dist/css/justifiedGallery.min.css?v=1.4'
import lightGallery from "lightgallery";
import lgvideo from 'lightgallery/plugins/video'
import 'lightgallery/css/lightgallery-bundle.min.css'
import { _showToast } from "../../../../../toastHelper";
import { IconTrashFilled, IconBrandYoutubeFilled, IconUpload } from '@tabler/icons-react'
import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
import AddVideo from "../../../MyInvitations/Common/Gallery/Add-Video/Add-Video";


const NewGallery = forwardRef(
  function NewGallery(props, ref) {
    const [gallery, setGallery] = useState([]);
    const [showAddVideoPopup, setShowAddVideoPopup] = useState(false);
    let myGallery = null;
    useEffect(() => {
      if (props.data && props.data.length > 0) {
        setGallery(props.data);
      }
    }, [props.data]);
console.log("gallery",gallery)
    useEffect(() => {
      $("#mygallery").justifiedGallery({
        rowHeight: 250,
        margins: 10,
        lastRow: 'justify',
        randomize: false
      });
    }, [gallery]);

    const updateLightGallery = (index) => {
      const lg = document.getElementById("mygallery");
      lg.addEventListener('lgAfterClose', destroyGallery);

      myGallery = lightGallery(lg,
        {
          autoplayFirstVideo: false,
          pager: false,
          galleryId: "mygallery",
          controls: true,
          download: false,
          rotate: false,
          plugins: [lgvideo],
          mobileSettings: {
            controls: false,
            showCloseIcon: true,
            download: false,
            rotate: false
          }
        });
      myGallery.openGallery(index);
    }

    const destroyGallery = (event) => {
      if (myGallery) {
        myGallery.destroy();
        myGallery = null;

        const lg = document.getElementById("mygallery");
        lg.removeEventListener('lgAfterClose', destroyGallery);
      }
    }

    const handleUploadImages = () => {
      document.getElementById("gallerybrowse").click();
    }

    const handleBrowseFiles = (event) => {
      if (event.target.files && event.target.files.length > 0) {
        let currentGallery = [...gallery];
        for (let i = 0; i < event.target.files.length; i++) {
          let imageItems = currentGallery.filter(galleryItem => galleryItem.type.toLowerCase() == 'image');
            let file = event.target.files[i];
            if (validateFile(file)) {
              const imageUrl = URL.createObjectURL(file);
              let galleryItem = {
                fileId: Math.floor((Math.random() * 10000) + 1),
                name: file.name,
                imageFile: file,
                image: imageUrl,
                type: 'image',
                videoUrl: "",
                videoImage: "",
                imageKey: "",
                isPrimaryVideo: false
              }
              currentGallery.push(galleryItem);
            }
        }
        setGallery(currentGallery);
      }
    }

    const validateFile = (file) => {
      let imageType = /image.*/;
      if (file && file.size > 2097152) {
        _showToast("Maximum file size allowed is 1MB.", "info");
        return false;
      }

      if (!file.type.match(imageType)) {
        _showToast("Invalid image type", "error");
        return false;
      }
      return true;
    }

    const removeItemHandler = (e, fileId) => {
      e.stopPropagation();
      e.preventDefault();
      const galleryItems = gallery.filter((item) => item.fileId !== fileId);
      const deletedItem = gallery.filter((item) => item.fileId === fileId);

      if (deletedItem && deletedItem.length > 0) {
        if (deletedItem[0].imageKey != "")
          props.imageDelete(deletedItem[0].imageKey);
      }

      setGallery(galleryItems);
      return false;
    }

    const setAsPrimaryHandler = (e, fileId) => {
      e.stopPropagation();
      e.preventDefault();
      const galleryItems = [...gallery];
      galleryItems.forEach(item => {
        if (item.fileId == fileId) {
          item.isPrimaryVideo = !item.isPrimaryVideo;
          _showToast("Primary video updated","success");
        }
        else {
          item.isPrimaryVideo = false;
        }
      });
      setGallery(galleryItems);
      return false;
    }


    const slideShowHandler = (e, index) => {
      e.stopPropagation();
      e.preventDefault();
      updateLightGallery(index);
    }


    const validate = () => {
      return true;
    }

    const getData = () => {
      return gallery;
    }
    useImperativeHandle(ref, () => ({
      validate: validate,
      getData: () => gallery,  // Ensure gallery state holds data
    }));
    

    return (
      <>
        <div className="content d-block visible">
          <div className="content-header mb-3 d-flex justify-content-between flex-column flex-md-row">
            <div className="sec-titler">
              {/* <h2 className="text-primary">Gallery</h2>
              <div className="title-shape"></div>
              <small className="fs-11 mb-0">File size should not be more than 1MB</small> */}
            </div>
            <div className="mb-0 text-right d-flex d-md-block flex-row justify-content-end">
              <button type="button" className="btn btn-primary align-middle me-3" onClick={handleUploadImages}>
                <IconUpload className="align-middle me-2" size={18} />Upload Images
              </button>

              {/* <button className="btn btn-primary align-middle" onClick={addVideoHandler}>
                <IconBrandYoutubeFilled className="align-middle me-2" size={18} />Video Link
              </button> */}

              <input className="d-none"
                name="file"
                type="file"
                id="gallerybrowse"
                accept="image/*"
                multiple="multiple"
                onChange={handleBrowseFiles}
              />
            </div>
          </div>
          {
            (!gallery || (gallery && gallery.length == 0)) && (
              <div className="row justify-content-center">
                <div className="col-md-5 col-lg-4 col-11">
                  <div className="d-flex flex-column align-items-center">
                    <img src="/images/upload-images.svg" />
                    <div className="helper-message">
                      No Images or Videos<br /> Upload to get started
                    </div>
                    <button type="button" className="mt-2 btn btn-primary btn btn-secondary" onClick={handleUploadImages}>
                      <IconUpload className="align-middle me-2" size={18} />Upload Images
                    </button>
                  </div>
                </div>
              </div>
            )
          }
          <div className="mt-2 d-flex w-100">
            {
              gallery && gallery.length > 0 && (
                <div id="mygallery">
                  {
                    gallery.map((item, index) => {
                      if (item.type == "image") {
                        return (
                          <a href={item.image} key={item.fileId} onClick={(e) => { slideShowHandler(e, index); return false; }}>
                            <img src={item.image} />
                            <div className="jg-caption">
                              <a onClick={(e) => { removeItemHandler(e, item.fileId); return false; }}
                                className="btn"><IconTrashFilled className="text-danger" size={22} /></a>
                            </div>
                          </a>)
                      }
                      else if (item.type == "youtube") {
                        return (
                          <a
                            data-lg-size="1280-720"
                            data-src={item.videoUrl}
                            data-poster={item.videoImage}
                            data-sub-html=""
                            key={item.fileId} onClick={(e) => { slideShowHandler(e, index); return false; }}
                          >
                            <img
                              width="300"
                              height="100"
                              className="img-responsive"
                              src={item.videoImage}
                            />
                            <div className="jg-caption">
                              <a onClick={(e) => { setAsPrimaryHandler(e, item.fileId); return false; }} className="btn me-2" style={{ padding: "11px 10px" }}>
                                {!item.isPrimaryVideo ? "Set as Primary" : "Remove as primary"}
                              </a>
                              <a onClick={(e) => { removeItemHandler(e, item.fileId); return false; }} className="btn"><IconTrashFilled className="text-danger" size={22} /></a>
                            </div>
                          </a>)
                      }
                    })
                  }
                </div>
              )
            }
          </div>
          <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} />
        </div >
        {/* {
          showAddVideoPopup && (
            <AddVideo onClose={closeAddVideoPopupHandler} addVideo={addVideo} />
          )
        } */}
      </>
    )
  });

export default NewGallery;